var _animateMotion;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJumpingArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    id: "svg996",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 8,24 -7.5,-7.5 H 5 V 8.5 h 6 v 8 h 4.5 z",
    style: {
      fill: "#868e96",
      stroke: "#373a3c",
      strokeWidth: 0
    },
    id: "path4"
  }, _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M 0 0 V -8 0 -4 Z",
    dur: "2s",
    repeatCount: "indefinite",
    keyPoints: "0;0;0.2;0.4;0.6;0.8;1",
    keyTimes: "0;0.3;0.4;0.5;0.6;0.75;1",
    calcMode: "linear"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpingArrow);
export default __webpack_public_path__ + "static/media/jumping-arrow.0a0e80c039a159a843352bfae653829b.svg";
export { ForwardRef as ReactComponent };